export const colors = {
  transparent: 'transparent',
  white: '#FFFFFF',
  black: '#000000',
  grey: {
    200: '#D8DADF',
    300: '#BCBEC4',
    400: '#9B9DA3',
    500: '#5F5C66',
    600: '#45474D',
    700: '#28282C',
    800: '#17181A',
  },
  blue: {
    50: '#E4F3FF',
    300: '#83A9EB',
    500: '#286BD7',
    700: '#1E54AE',
  },
  purple: {
    100: '#EBD5FF',
    200: '#E0BCFF',
    300: '#BA83EB',
    400: '#9F00FF',
    500: '#64049D',
  },
  red: {
    300: '#FDA29B',
    500: '#F92807',
    700: '#BF184C',
  },
  green: {
    500: '#12B76A',
  },
  yellow: {
    500: '#FFD300',
  },
};

export const opacity = {
  5: '0C',
  10: '19',
  12: '1E',
  15: '26',
  20: '33',
  25: '3F',
  30: '4C',
  40: '66',
  50: '7F',
  60: '99',
  70: 'B2',
  80: 'CC',
  90: 'E5',
  100: 'FF',
};

export const colorsPalette = [
  '#008CB4',
  '#0056D6',
  '#371A94',
  '#7A219E',
  '#99244F',
  '#E22400',
  '#DA5100',
  '#D38301',
  '#D19D01',
  '#F5EC00',
  '#C3D117',
  '#669D34',
  '#00A1D8',
  '#0061FD',
  '#4D22B2',
  '#982ABC',
  '#B92D5D',
  '#FF4015',
  '#FF6A00',
  '#FFAB01',
  '#FCC700',
  '#FEFB41',
  '#D9EC37',
  '#76BB40',
  '#01C7FC',
  '#3A87FD',
  '#5E30EB',
  '#BE38F3',
  '#E63B7A',
  '#FE6250',
  '#FE8648',
  '#FEB43F',
  '#FECB3E',
  '#FFF76B',
  '#E4EF65',
  '#96D35F',
  '#52D6FC',
  '#74A7FF',
  '#864FFD',
  '#D357FE',
  '#EE719E',
  '#FF8C82',
  '#FEA57D',
  '#FEC777',
  '#FED977',
  '#FFF994',
  '#EAF28F',
  '#B1DD8B',
  '#93E3FC',
  '#A7C6FF',
  '#B18CFE',
  '#E292FE',
  '#F4A4C0',
  '#FFB5AF',
  '#FFC5AB',
  '#FED9A8',
  '#FDE4A8',
  '#FFFBB9',
  '#F1F7B7',
  '#CDE8B5',
  '#FFFFFF',
  '#D2E2FE',
  '#D8C9FE',
  '#EFCAFE',
  '#F9D3E0',
  '#FFDAD8',
  '#FFE2D6',
  '#FEECD4',
  '#FEF1D5',
  '#FDFBDD',
  '#F6FADB',
  '#DEEED4',
];
